import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";

interface InfoProps {
  Icon: IconType;
  amount: number;
  subtitle: string;
  onClick?: () => void;
  animationDuration?: number; // duração da animação em ms
}

const InfoCard: React.FC<InfoProps> = ({
  Icon,
  amount,
  subtitle,
  onClick,
  animationDuration = 2000, // duração padrão de 1 segundo
}) => {
  const [displayedAmount, setDisplayedAmount] = useState(0);

  useEffect(() => {
    const startTime = performance.now();
    const increment = (timestamp: number) => {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / animationDuration, 1); // normaliza o progresso (0 a 1)
      setDisplayedAmount(Math.round(progress * amount));

      if (progress < 1) {
        requestAnimationFrame(increment);
      }
    };

    requestAnimationFrame(increment);
  }, [amount, animationDuration]);

  return (
    <button
      onClick={onClick}
      className="info-card transition-transform hover:scale-105 dark:border-zinc-800 dark:bg-zinc-800"
    >
      <div className="flex flex-col">
        <h1 className="text-3xl font-semibold uppercase text-zinc-800 dark:text-white">
          {displayedAmount}
        </h1>
        <h3 className="text-xs font-semibold uppercase text-zinc-500">
          {subtitle}
        </h3>
      </div>
      <Icon size={40} className="text-zinc-800 dark:text-zinc-400" />
    </button>
  );
};

export default InfoCard;
